import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { get_auth_key, getStoredData } from '../util';
import { useLocation } from 'react-router-dom';
import {
  menu_list,
  adminMenu,
  vehicleManagerMenu,
  machineManagerMenu,
  faAdminMenu,
  faManagerMenu,
  storeOperatorMenu,
  festivalManagerMenu,
  festivalAdminMenu,
  superAdminMenu,
  couponAdminMenu,
  inventoryManagerMenuWithGodownLocation,
  inventoryManagerMenu,
  inventoryAdminMenu,
  cakeManagerMenu,
  JWCollectorMenu,
  agreementMenu,
  adsManagerMenu,
  storeManagerMenu,
  couponManagerMenu,
} from '../util/menu.util';

const SideBar = () => {
  const hiddenMenu = useSelector((state) => state.menu.isMenuOpen);

  const onMenuSelection = useCallback((item) => {
    if (item.children && item.children.length) {
      return;
    }
  }, []);

  const currentRole = useSelector((state) => state?.menu?.role);

  const menu = useMemo(() => {
    const storedData = JSON.parse(getStoredData(get_auth_key()));
    if (storedData?.role === 'admin') {
      return adminMenu;
    } else if (storedData?.role === 'vehicle-manager') {
      return vehicleManagerMenu;
    } else if (storedData?.role === 'machine-manager' || storedData?.role === 'machine-admin') {
      return machineManagerMenu;
    } else if (storedData?.role === 'fixed-asset-admin') {
      return faAdminMenu;
    } else if (storedData?.role === 'fixed-asset-manager') {
      return faManagerMenu;
    } else if (storedData?.role === 'store-operator') {
      return storeOperatorMenu;
    } else if (storedData?.role === 'festival-manager') {
      return festivalManagerMenu;
    } else if (storedData?.role === 'festival-admin') {
      return festivalAdminMenu;
    } else if (storedData?.role === 'super-admin') {
      return superAdminMenu;
    } else if (storedData?.role === 'coupon-admin') {
      return couponAdminMenu;
    } else if (storedData?.role === 'inventory-manager' && +storedData?.locationId[0] === 116) {
      return inventoryManagerMenuWithGodownLocation;
    } else if (storedData?.role === 'inventory-manager') {
      return inventoryManagerMenu;
    } else if (storedData?.role === 'inventory-admin') {
      return inventoryAdminMenu;
    } else if (storedData?.role === 'cake-admin') {
      const cakeAdminMenu = menu_list.filter((menu) => menu.id === 9);
      return cakeAdminMenu;
    } else if (storedData?.role === 'cake-manager') {
      return cakeManagerMenu;
    } else if (storedData?.role === 'jw-collector') {
      return JWCollectorMenu;
    } else if (storedData?.role === 'agreement-admin') {
      return agreementMenu;
    } else if (storedData?.role === 'ads-manager') {
      return adsManagerMenu;
    } else if (storedData?.role === 'store-manager') {
      return storeManagerMenu;
    } else if (storedData?.role === 'coupon-manager') {
      return couponManagerMenu;
    }
  }, [menu_list, currentRole]);

  const main_menu = [
    {
      id: 999999,
      label: 'Dashboard',
      link: '/dashboard',
    },
  ].concat(menu);

  return (
    <>
      {/* {storedData?.role === 'cake-manager' ? (
        ''
      ) : ( */}
      <div className={hiddenMenu === false ? 'menu-wrapper' : 'menu-wrapper menu-hidden'}>
        <ul className="list">
          {main_menu?.map((item, index) => {
            return (
              <li
                className="menu-item"
                key={`menu_${item?.id}_${index}`}
                onClick={() => {
                  onMenuSelection(item);
                }}
              >
                <MenuItem item={item} onMenuSelection={onMenuSelection} />
              </li>
            );
          })}
        </ul>
      </div>
      {/* )} */}
    </>
  );
};

const MenuItem = ({ item, onMenuSelection }) => {
  const hasChildren = useMemo(() => {
    return !!(item && item.children && item.children.length);
  }, [item]);
  if (hasChildren) {
    return <MenuItemWithChild item={item} onMenuSelection={onMenuSelection} />;
  } else {
    return (
      <NavLink to={item?.link} className="menu-link">
        {item?.label}
      </NavLink>
    );
  }
};
const MenuItemWithChild = ({ item, onMenuSelection }) => {
  const [isExpand, setExpand] = useState(false);
  const location = useLocation();

  const isLinkActive = (item, location) => {
    if (item.link === location.pathname) {
      return true;
    }
    return item.children && item.children.some((child) => isLinkActive(child, location));
  };

  const isActive = useMemo(() => isLinkActive(item, location), [item, location]);

  useMemo(() => {
    if (isActive) {
      setExpand(true);
    }
  }, [isActive]);

  const handleToggle = () => {
    setExpand(!isExpand);
  };

  return (
    <React.Fragment>
      <span className={`menu-link has-children ${(isExpand && 'is-open') || ''}`.trim()} onClick={handleToggle}>
        {item.label}
      </span>
      <ul className={`list ${isExpand ? 'opened' : 'closed'}`.trim()}>
        {((item && item.children) || []).map((subItem, index) => {
          return (
            <li className="menu-item" key={`menu_${subItem.id}_${index}`} onClick={() => onMenuSelection(subItem)}>
              <MenuItem item={subItem} onMenuSelection={onMenuSelection} />
            </li>
          );
        })}
      </ul>
    </React.Fragment>
  );
};

export default SideBar;
